import React, { useState, useEffect } from 'react';
import { useQuery, useLazyQuery, useMutation } from 'react-apollo';
import {
  Form, ButtonGroup, Button,
} from 'reactstrap';
import { useToasts } from 'react-toast-notifications';
import ReactImageFallback from 'react-image-fallback';
import {
  LOGO_LARGE_WHITE,
  handleGraphqlError,
  mapTagstoAPIRequest,
  mapTagsFromAPIRequest,
  getLocalUserData,
  staticConstants,
  history,
  routeConstants,
  FALLBACK_DARK_ICON,
  capitalizeEveryWord,
}
  from '../../../utils';
import questionnaires from '../../../utils/categoryConstants';
import QuestionnaireCard from './QuestionnaireCard';
import Loading from '../loadingOverlay/Loading';
import SettingsContainer from '../settings/SettingsContainer';
import {
  GET_BRANDS, GET_ACTIVE_ARTIST, GET_USER_DATA_QUERY, GET_ALL_ARTIST_QUERY,
} from '../../../graphql-client/queries';
import { UPDATE_INTREST, LOADER_MUTATION, UPDATE_USER } from '../../../graphql-client/mutations';

const newLocal = 'Please fill category data';
function Questionnaire({ editMode }) {
  const userData = getLocalUserData();
  const [brands, setBrands] = useState(null);
  const { addToast } = useToasts();
  const [userApiData] = useState();
  const [intrestApiData, setIntrestApidata] = useState();
  const [loaderValue, setLoaderValue] = useState(false);
  const [loginUser, setLoginUser] = useState();
  const [canSaveIntrest, setCanSaveIntrest] = useState(false);
  const [intrests, setIntrests] = useState();
  let categories = [];

  const [getAllArtistQuery, {
    loading: artistQueryLoading, data: allArtists,
  }] = useLazyQuery(GET_ALL_ARTIST_QUERY, { skip: userData.role !== staticConstants.ROLE.MANAGER });

  const [activeArtistQuery, { loading: activeArtistLoading, data: activeArtistData },
  ] = useLazyQuery(GET_ACTIVE_ARTIST);
  const { loading: getBrandsLoading, data: brandsData } = useQuery(GET_BRANDS, {
    onError: (err) => {
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },
  });
  const {
    loading: getUserLoading, data: getUserData, refetch: getUserRefetch,
  } = useQuery(GET_USER_DATA_QUERY, { variables: userApiData });
  const [loaderMutate] = useMutation(LOADER_MUTATION, {
    variables: { show: loaderValue },
  });
  const [updateIntrestsMutation] = useMutation(UPDATE_INTREST, {
    variables: intrestApiData,
    refetchQueries: [{ query: GET_USER_DATA_QUERY }],
    awaitRefetchQueries: true,
    onError(err) {
      setLoaderValue(false);
      loaderMutate();
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(profileData) {
      setLoaderValue(false);
      loaderMutate();
      addToast(profileData.updateIntrests.message, { appearance: 'success' });
      history.push(routeConstants.DASHBOARD);
    },

  });

  const [updateArtistProfile] = useMutation(UPDATE_USER, {
    variables: {},
    onError(err) {
      loaderMutate({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted() {
      loaderMutate({ variables: { show: false } });
    },
  });

  useEffect(() => {
    if (userData.role === staticConstants.ROLE.MANAGER) {
      activeArtistQuery();
      getAllArtistQuery();
    }
  }, []);

  useEffect(() => {
    if (activeArtistData) {
      getUserRefetch({ userId: activeArtistData.activeArtist._id });
    }
  },
  [activeArtistData]);
  useEffect(() => {
    if (getUserData?.getUser?.data) {
      const data = getUserData.getUser.data.category;
      if (data) {
        const category = data.map((el) => ({
          label: el.name,
          value: el._id,
          subCategory: el.subCategory ? mapTagsFromAPIRequest(el.subCategory) : null,
        }));
        setIntrests(category);
      }
      setLoginUser(getUserData.getUser.data);
    }
  }, [getUserData]);
  useEffect(() => {
    if (brandsData && brandsData.getCategory) {
      setBrands(brandsData.getCategory.data);
    }
  }, [brandsData]);

  useEffect(() => {
    if (intrestApiData) {
      setLoaderValue(true);
      loaderMutate();
      updateIntrestsMutation();
    }
  }, [intrestApiData]);

  if (getBrandsLoading || getUserLoading || activeArtistLoading || artistQueryLoading) {
    return <Loading active />;
  }

  const getBrands = (brandName) => {
    if (brands) {
      return brands.find((el) => el && el.name === brandName);
    }
    return null;
  };

  const getInrests = (brandName) => {
    if (intrests) {
      const ret = intrests.find((el) => el && el.label === brandName);
      return ret && ret.subCategory;
    }
    return null;
  };
  const brandsChangeCallback = (data, brandId, brandName) => {
    const ind = categories.findIndex((el) => el._id === brandId);
    if (ind > -1) {
      categories[ind] = { ...categories[ind], ...{ subCategory: data ? mapTagstoAPIRequest(data) : null } };
    } else { categories.push({ _id: brandId, name: brandName, subCategory: data ? mapTagstoAPIRequest(data) : null }); }
    categories = categories.filter((el) => el.subCategory !== null);
    !canSaveIntrest && setCanSaveIntrest(true);
  };

  const saveIntrests = (e) => {
    e.preventDefault();
    if (!categories || categories.length < 1) {
      addToast(newLocal, { appearance: 'error' });
      return;
    }
    const intrestData = { category: categories };
    if (activeArtistData) {
      intrestData.artistId = activeArtistData.activeArtist._id;
    }
    setLoaderValue(true);
    loaderMutate();
    setIntrestApidata(intrestData);
  };

  const getActiveArtistName = () => {
    if (allArtists && allArtists.getAllArtist && activeArtistData) {
      const data = allArtists.getAllArtist.data.find((da) => da._id === activeArtistData.activeArtist._id);
      return data.name;
    }
    return null;
  };
  const getActiveArtistImage = () => {
    if (allArtists && allArtists.getAllArtist && activeArtistData) {
      const data = allArtists.getAllArtist.data.find((da) => da._id === activeArtistData.activeArtist._id);
      return data.artistImage;
    }
    return null;
  };

  const skipInterestSelection = () => {
    updateArtistProfile({ variables: { isQuestionnaireSkipped: true } });
    const localUser = getLocalUserData();
    if (localUser) {
      localUser.isQuestionnaireSkipped = true;
      localStorage.setItem('user', JSON.stringify(localUser));
    }
    history.push(routeConstants.DASHBOARD, { isQuestionnaireSkipped: true });
  };
  return (
    <div className="questionnaire">
      <div className="questionnaire-head">
        <div className="questionnaire-head-logo">
          <img
            src={LOGO_LARGE_WHITE}
            alt="BYG music"
          />
        </div>
        <div className="questionnaire-head-user-quote">
          <div className="questionnaire-head-user-quote-image">
            {userData.role === staticConstants.ROLE.MANAGER
              && (
                <ReactImageFallback
                  src={getActiveArtistImage() || FALLBACK_DARK_ICON}
                  fallbackImage={FALLBACK_DARK_ICON}
                  alt="profile"
                  className="image-cover"
                />
              )}
            {userData.role === staticConstants.ROLE.ARTIST
              && (
                <ReactImageFallback
                  src={(loginUser && loginUser.artistImage) || FALLBACK_DARK_ICON}
                  fallbackImage={FALLBACK_DARK_ICON}
                  alt="profile"
                  className="image-cover"
                />
              )}
          </div>
          {!editMode
            && (
            <>
              <h1 className="font-caveat">
                Welcome
                {' '}
                {userData.role === 'artist' ? (
                  `${loginUser && capitalizeEveryWord(loginUser.name)}`
                ) : (
                  `${getActiveArtistName()}`
                )}
              </h1>
              <p className="font-caveat">
                We want to know more about you so we can partner you with
                the right brand! Please fill out the following questionnaire.
              </p>
            </>
            )}
          {
            editMode && (
            <p className="font-caveat">
              Edit interests
            </p>
            )
          }
        </div>
        <div className="questionnaire-head-dropdown">
          <div className={(intrests && intrests.length) && 'd-none'}>
            <SettingsContainer skipInterestSelectionForm={loginUser?.isQuestionnaireSkipped} />
          </div>
          {intrests && intrests.length > 0 && <span className="icon icon-cross cursor-pointer" onClick={() => { history.push(routeConstants.DASHBOARD); }} />}

        </div>
      </div>
      <Form className="questionnaire-form">
        {!editMode && (
        <p className="questionnaire-form-heading">
          Select the category that interests you & mention your favourite brands. Check the boxes next to the category names and type in specific brands that you love.
        </p>
        )}
        <>
          {questionnaires.map((el) => (
            <QuestionnaireCard
              icon={el.icon}
              heading={el.heading}
              tagLine={el.tagLine}
              brands={getBrands(el.heading)}
              brandsChangeCallback={brandsChangeCallback}
              intrests={getInrests(el.heading)}
              key={el.icon}
            />
          ))}
        </>
        <ButtonGroup className="justify-content-center mt-2">
          <Button
            type="button"
            element="inlineBlock"
            color="primary"
            className="btn-lg"
            onClick={saveIntrests}
            disabled={!canSaveIntrest}
          >
            Save details
          </Button>

        </ButtonGroup>
        {!editMode && (
        <ButtonGroup className="justify-content-center mt-2 pt-3">
          <Button
            type="button"
            color="blank"
            className="skip-interest-btn"
            onClick={skipInterestSelection}
          >
            Skip and do later
          </Button>
        </ButtonGroup>
        )}
      </Form>
    </div>
  );
}

export default Questionnaire;
